'use strict';

angular.module('TurneroApp').component('coEstadoDeSalon', {
	bindings: {
		centroAtencionSeleccionado: '<'
	},
	controller: [
		 'agendaService',
		 'utilsService',
		 'estadisticaService',
		 'usuariosService',
		 'tramiteService',
		 'turnosService',
		 'TurneroAppConstant',
		 '$interval',
		 '$state',
	function (agendaService, utilsService, estadisticaService, usuariosService, tramiteService, turnosService, TurneroAppConstant, $interval, $state) {
		var ctrl = this;
		ctrl.mostrarFiltro = true;
		ctrl.limitOptions = [10, 25, 50, 75, 100, {
			label: 'Todos',
			value: function () {
				return ctrl.pagination.total;
			}
		}];

		ctrl.query = {
			limit: 10,
			page: 1,
			filter: ''
		};

		//Se inicializa en null para que al principio no tome que no hay valores
		ctrl.pagination = {
			total: null
		};
		ctrl.permisos = TurneroAppConstant.Permisos;
		ctrl.limpiarMemoria = function () {
			ctrl.EstadoSalon = {
				Finalizados: null,
				AtencionEnCurso: null,
				Esperando: null,
				NoPresentados: null,
				TurnosParaHoy: null,
				TurnosOrdenDeLlegada: null,
				TurnosDerivados: null,
				TurnosPerdidos: null,
				MayorTiempoEspera: null,
				PromedioEspera: null,
				MayorTiempoEsperaTurno: null,
				PromedioEsperaActual: null,
				MayorTiempoEsperaSinTurno: null
			}
		};

		ctrl.$onChanges = function () {
			ctrl.Filtro = {};
			ctrl.limpiarMemoria();
			ctrl.centroAtencionSeleccionado && ctrl.cargarFiltros();
			ctrl.centroAtencionSeleccionado && ctrl.actualizarListados();

		}

		ctrl.actualizarListados = function () {
			ctrl.limpiarMemoria();
			var filtro = {
				Id_Centro_Atencion: ctrl.centroAtencionSeleccionado.id,
				Id_Agenda: ctrl.Filtro.Agenda ? ctrl.Filtro.Agenda.id : null,
				Id_Usuario: ctrl.Filtro.Agente ? ctrl.Filtro.Agente.id : null,
				Id_Tramite_Relevado: ctrl.Filtro.Tramite ? ctrl.Filtro.Tramite.id : null
			}

			ctrl.turnosPerdidos(filtro);
			ctrl.personasAusentes(filtro);
			ctrl.atencionesFinalizadas(filtro);
			ctrl.atencionenCurso(filtro);
			ctrl.personasEsperando(filtro);
			ctrl.turnosParaHoy(filtro);
			ctrl.turnosOrdenDeLlegada(filtro);
			ctrl.turnosDerivados(filtro);
			ctrl.promedioActual(filtro);
			ctrl.promedioDia(filtro);
			ctrl.turnoMasEsperadoOrden(filtro);
			ctrl.turnoMasEsperadoNoOrden(filtro);
			ctrl.ObtenerTurnosParaHoy(filtro);
			ctrl.mayorEsperaActual(filtro);

			ctrl.ultimaActualizacion = moment().toDate();
		};

		ctrl.cargarFiltros = function () {
			ctrl.promiseAgendas = agendaService.Get_Agendas_Combo({ 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (resultado) {
				ctrl.Agendas = resultado.Data;
				ctrl.Tramites = null
			}).catch(function (error) {
				utilsService.errores(error);
			});
			ctrl.promiseAgentes = usuariosService.Traer_Usuarios_Activos_Combo({ 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (resultado) {
				ctrl.Agentes = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});

			ctrl.promiseEstados = turnosService.Get_Estados_Combo().$promise.then(function (resultado) {
				ctrl.Estados = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			})
		}

		ctrl.cargarTramites = function (item) {
			ctrl.Tramites = null;
			ctrl.promiseTramites = tramiteService.Get_X_Agenda({ 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id, 'id_agenda': item.id }).$promise.then(function (resultado) {
				ctrl.Tramites = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}

		ctrl.turnosPerdidos = function (filtro) {
			estadisticaService.Get_Turnos_Perdidos(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.TurnosPerdidos = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.personasAusentes = function (filtro) {
			estadisticaService.Get_Turnos_No_Presentes(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.NoPresentados = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.atencionesFinalizadas = function (filtro) {
			estadisticaService.Get_Turnos_Finalizados(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.Finalizados = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.atencionenCurso = function (filtro) {
			estadisticaService.Get_Turnos_En_Atencion(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.AtencionEnCurso = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.personasEsperando = function (filtro) {
			estadisticaService.Get_Turnos_En_Espera(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.Esperando = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.turnosParaHoy = function (filtro) {
			estadisticaService.Get_Turnos_Agendados(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.TurnosParaHoy = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.turnosOrdenDeLlegada = function (filtro) {
			estadisticaService.Get_Turnos_Agendados_Orden(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.TurnosOrdenDeLlegada = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.turnosDerivados = function (filtro) {
			estadisticaService.Get_Turnos_Derivados(filtro).$promise.then(function (resultado) {
				ctrl.EstadoSalon.TurnosDerivados = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		// TIEMPOS 
		ctrl.promedioActual = function (filtro) {
			estadisticaService.Get_Promedio_Actual(filtro).$promise.then(function (resultado) {
				var FechaString = resultado.Data ? (resultado.Data.Horas + ':' + resultado.Data.Minutos + ':' + resultado.Data.Segundos).toString() : '00:00:00'
				ctrl.EstadoSalon.PromedioEsperaActual = moment(FechaString, "HH:mm:SS").toDate();
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.promedioDia = function (filtro) {
			estadisticaService.Get_Promedio_Dia(filtro).$promise.then(function (resultado) {
				var FechaString = resultado.Data ? (resultado.Data.Horas + ':' + resultado.Data.Minutos + ':' + resultado.Data.Segundos).toString() : '00:00:00'
				ctrl.EstadoSalon.PromedioEspera = moment(FechaString, "HH:mm:SS").toDate();
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}

		ctrl.mayorEsperaActual = function (filtro) {
			estadisticaService.Get_Mas_Espera_Actual(filtro).$promise.then(function (resultado) {
				var FechaString = resultado.Data ? (resultado.Data.Horas + ':' + resultado.Data.Minutos + ':' + resultado.Data.Segundos).toString() : '00:00:00'
				ctrl.EstadoSalon.MayorTiempoEspera = moment(FechaString, "HH:mm:SS").toDate();
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.turnoMasEsperadoOrden = function (filtro) {
			estadisticaService.Get_Mas_Espera_Orden(filtro).$promise.then(function (resultado) {
				var FechaString = resultado.Data ? (resultado.Data.Horas + ':' + resultado.Data.Minutos + ':' + resultado.Data.Segundos).toString() : '00:00:00'
				ctrl.EstadoSalon.MayorTiempoEsperaSinTurno = moment(FechaString, "HH:mm:SS").toDate();
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}
		ctrl.turnoMasEsperadoNoOrden = function (filtro) {
			estadisticaService.Get_Mas_Espera_No_Orden(filtro).$promise.then(function (resultado) {
				var FechaString = resultado.Data ? (resultado.Data.Horas + ':' + resultado.Data.Minutos + ':' + resultado.Data.Segundos).toString() : '00:00:00'
				ctrl.EstadoSalon.MayorTiempoEsperaTurno = moment(FechaString, "HH:mm:SS").toDate();
			}).catch(function (error) {
				utilsService.errores(error);
			});
		}

		ctrl.cargaGrilla = function () {
			ctrl.ObtenerTurnosParaHoy(null);
		}

		ctrl.ObtenerTurnosParaHoy = function (filtro) {
			if (filtro) {
				filtro.Id_Estado = ctrl.Filtro.Estado ? ctrl.Filtro.Estado.id : null
			} else {
				var filtro = {
					Id_Centro_Atencion: ctrl.centroAtencionSeleccionado.id,
					Id_Agenda: ctrl.Filtro.Agenda ? ctrl.Filtro.Agenda.id : null,
					Id_Usuario: ctrl.Filtro.Agente ? ctrl.Filtro.Agente.Id_Usuario : null,
					Id_Tramite_Relevado: ctrl.Filtro.Tramite ? ctrl.Filtro.Tramite.id : null,
					Id_Estado: ctrl.Filtro.Estado ? ctrl.Filtro.Estado.id : null,
				}
			}
			filtro.Nro_Pagina = ctrl.query.page;
			filtro.Tam_Pagina = ctrl.query.limit;

			ctrl.promise = estadisticaService.Get_Turnos_Salon(filtro).$promise.then(function (resultado) {
				ctrl.pagination.total = resultado.Paging.Reg_Totales;
				ctrl.EstadoSalon.Turnos = resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
			});

		}

		ctrl.fechaCounter = new Date();
		//RELOJ
		function tick(value) {
			if ($state.$current.name != "admin.estadoDelSalon") {
				if (angular.isDefined(ctrl.timer)) {
					$interval.cancel(ctrl.timer);
				}
			}
			//console.log($state);
			ctrl.fechaCounter = moment(ctrl.ultimaActualizacion, "YYYY-MM-DD HH:mm:ss");
			if (moment(moment().format("YYYY-MM-DD HH:mm:ss")).diff(ctrl.fechaCounter, 'm') >= 10) {
				ctrl.actualizarListados()
			}
		}

		tick();
		ctrl.timer = $interval(tick, 1000);



	}
	],
	template: require('./estadoDeSalon.html')
});



// WEBPACK FOOTER //
// ./app/components/supervision/estadosDeSalonComponent.js